import { useQuery } from 'react-query'

import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { LinkedBankAccount } from '@webapp/platform/banking/entities/LinkedBankAccount'
import { linkedBankAccountQueryConfig } from '@webapp/platform/banking/query-configs/linkedBankAccount'

type UseQueryLinkedBankAccountsReturn = {
  linkedBankAccounts: LinkedBankAccount[]
  isFetching: boolean
}

export const useQueryLinkedBankAccounts = ({
  params,
  onError,
  enabled = true,
}: {
  params?: RepoFilterParams
  onError: () => void
  enabled?: boolean
}): UseQueryLinkedBankAccountsReturn => {
  const { data, isFetching } = useQuery({
    ...linkedBankAccountQueryConfig.getLinkedBankAccounts(params),
    enabled,
    onError,
  })

  const linkedBankAccounts = data?.data ?? []

  return {
    linkedBankAccounts: linkedBankAccounts.map(
      (account) => new LinkedBankAccount(account)
    ),
    isFetching,
  }
}
